import { Row } from 'further-ui/components/Layout';
import { FC, PropsWithChildren } from 'react';

type Props = {
  className?: string;
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
};

const FiltersGroup: FC<PropsWithChildren<Props>> = ({
  children,
  className,
  justify = 'flex-start',
}) => {
  return (
    <Row
      spacing="md"
      centered
      breakpoint="md"
      fullWidth
      className={className}
      justify={justify}
    >
      {children}
    </Row>
  );
};

export default FiltersGroup;
